module.exports = __webpack_public_path__ + "img/registration_at_back.33926c7f.svg";